<template>
  <div class="sai-iframe-wrapper">
    <iframe ref="iframeRef" :src="saiUrl" class="sai-iframe-content" title="S-AI" frameborder="0" @load="onIframeLoad" @error="onIframeError" />
    <!-- 왼쪽 리사이즈 핸들 영역만 드래그 중일 때만 표시되는 overlay -->
    <div v-if="isDragging" class="resize-handle-blocker"></div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useSaiChatStore } from '~/composables/saiChat/useSaiChatStore';

const iframeRef = ref(null);
const saiChatStore = useSaiChatStore();

// 드래그 감지를 위한 변수
const isDragging = ref(false);

// isDragging 값 변경 감시
watch(isDragging, newVal => {
  console.log('🖱️ isDragging:', newVal);
});

// document 레벨에서 리사이즈 핸들의 mousedown 감지
const handleDocumentMouseDown = e => {
  // 리사이즈 핸들인지 확인
  const resizeHandle = e.target.closest('.ui-popup__resize-handle');
  if (resizeHandle) {
    // 리사이즈 핸들을 잡았을 때 바로 isDragging을 true로 설정
    isDragging.value = true;
  }
};

// document 레벨에서 마우스 업 감지
const handleDocumentMouseUp = e => {
  // 리사이즈가 끝났을 때 isDragging을 false로 설정
  if (isDragging.value) {
    isDragging.value = false;
  }
};

onMounted(() => {
  // document 레벨에서 mousedown과 mouseup 이벤트 리스너 추가
  document.addEventListener('mousedown', handleDocumentMouseDown);
  document.addEventListener('mouseup', handleDocumentMouseUp);
});

onUnmounted(() => {
  // 컴포넌트 언마운트 시 이벤트 리스너 제거
  document.removeEventListener('mousedown', handleDocumentMouseDown);
  document.removeEventListener('mouseup', handleDocumentMouseUp);
});

// Store에서 SAI URL 가져오기 (토큰 포함)
const saiUrl = computed(() => {
  // store에 URL이 있으면 사용, 없으면 기본 URL
  if (saiChatStore.saiUrl) {
    return saiChatStore.saiUrl;
  }

  // 기본 URL (토큰 없이)
  const runtimeConfig = useRuntimeConfig();
  return runtimeConfig.public.saiUrl || 'http://localhost:8100/sai';
});

// iframe 로딩 완료 핸들러
const onIframeLoad = () => {
  console.log('✅ SAI iframe 로딩 완료:', saiUrl.value);
};

// iframe 에러 핸들러
const onIframeError = () => {
  console.error('❌ SAI iframe 로딩 실패:', saiUrl.value);
};
</script>

<style lang="scss" scoped>
.sai-iframe-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.sai-iframe-content {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  pointer-events: auto; /* iframe 내부 상호작용 가능 */
}

/* 왼쪽 리사이즈 핸들 영역만 마우스 이벤트를 막는 overlay */
.resize-handle-blocker {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 400px; /* 리사이즈 핸들 영역보다 넓게 */
  z-index: 5; /* iframe 위에 표시되지만 리사이즈 핸들(z-index: 10)보다는 아래 */
  pointer-events: auto; /* 이 영역의 마우스 이벤트를 막아서 리사이즈 핸들이 받을 수 있도록 */
  background: transparent;
  /* 이 overlay가 마우스 이벤트를 받아서 iframe으로 전달되지 않도록 함 */
}
</style>
